module.exports = __webpack_public_path__ + "media/country_flags/li-c000f422.png";